
import {
  FileDescriptor, FileDocument, FileDocumentStatus, Time,
} from '@/model';
import Vue from 'vue';
import LabelPanel from '@/components/LabelPanel.vue';
import { RouteNames } from '@/router/route-names';
import labels from '@/store/labels';
import { documentPublishedLabel, formatDocumentPublished, isDocumentStatusVisible } from '@/store/ui-config';
import { notEmpty } from '@/util/array-util';
import DocumentEditor from '@/components/DocumentEditor.vue';
import api from '@/rest-api';

interface Panel {
  name: string;
  status: FileDocumentStatus;
  open: boolean;
}

export default Vue.extend({
  name: 'HomeView',
  components: {
    LabelPanel, DocumentEditor,
  },

  props: {
    documents: { type: Array as () => FileDocument[], required: true },
    loading: { type: Boolean, default: () => false },
  },

  data() {
    return {
      editItem: {} as Partial<FileDocument> | undefined,
      edit: false,
      fileDetails: undefined as FileDescriptor | undefined,
      panels: [
        { name: 'Analysis', status: 'analysis', open: true },
        { name: 'QA', status: 'qa', open: true },
        { name: 'Pending Summaries', status: 'summary', open: true },
        { name: 'Completed', status: 'completed', open: false },
        { name: 'Pending', status: 'pending', open: false },
      ] as Panel[],
    };
  },

  computed: {
    headers() {
      return [
        { text: 'Id', align: 'start', value: 'id' },
        { text: 'Author', value: 'publisher.name' },
        { text: 'Name', value: 'name' },
        { text: 'License', value: 'license' },
        { text: documentPublishedLabel(), value: 'published' },
        { text: 'Persisted', value: 'file.persisted' },
        { text: 'Labels', value: 'labels', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ];
    },
    visiblePanels(): Panel[] {
      return this.panels.filter((panel) => isDocumentStatusVisible(panel.status));
    },
  },

  methods: {
    filterDocuments(status: FileDocumentStatus): FileDocument[] {
      return this.documents.filter((d) => d.status === status);
    },
    dateTime(t: Time) {
      return t && Time.asString(t);
    },
    date(t: Time) {
      return t && Time.asDateString(t);
    },
    published(t: Time) {
      return formatDocumentPublished(t);
    },
    isPdf(file: FileDescriptor): boolean {
      return file.mime === 'application/pdf';
    },
    showDocumentResult(doc: FileDocument) {
      this.$router.push({ name: RouteNames.DocumentResult, params: { documentId: `${doc.id}` } });
    },
    toLabels(ids: number[]) {
      return ids.map((id) => labels.getters.lookup.get(id)).filter(notEmpty);
    },
    newDocument() {
      this.editItem = undefined;
      this.edit = true;
    },
    saved(_: FileDocument) {
      this.$emit('load');
    },
    reingest(doc: FileDocument) {
      this.$emit('reingest', doc);
    },
    downloadUrl(file: FileDescriptor | undefined, forceSave?: boolean) {
      return file ? api.fileDownloadUri(file.uuid, forceSave) : undefined;
    },
    editDocument(item: FileDocument) {
      this.editItem = { ...item };
      this.edit = true;
    },
    displayLicense(document: FileDocument): string | undefined {
      return document.license === undefined ? document.publisher?.license : document.license;
    },
    doShowSummaries(document: FileDocument) {
      this.$router.push({ name: RouteNames.Summaries, query: { documentId: `${document.id}` } });
    },
    doShowFragments(document: FileDocument) {
      this.$router.push({ name: RouteNames.Selection, query: { documentId: `${document.id}` } });
    },
  },
});
